<template>
    <div>
        <ol class="breadcrumb page-breadcrumb">
            <li class="breadcrumb-item"><a class="text-primary text-uppercase">{{category}}</a></li>
            <li v-if="subCategory != ''" class="breadcrumb-item active">{{subCategory}}</li>
            <li v-if="subSubCategory != ''" class="breadcrumb-item active">{{subSubCategory}}</li>
        </ol>
        <div class="subheader mb-0">
            <h1 class="subheader-title">
                <i v-if="icon != ''" class='fas' :class="icon"></i>
                <img v-else class="img-fluid img-social" :src="require('@/assets/image/icon/tukangLogo.png')"/>
                <span v-if="subCategory == ''" class="ml-3">{{category}}</span>
                <span v-else class="ml-3">{{subSubCategory == '' ? subCategory : subSubCategory}}</span>
            </h1>
        </div>
    </div>
</template>
<script>
export default {
    name: 'breadCrumb',
    props:{
        category: String,
        subCategory: String,
        subSubCategory: String,
        icon: String
    }, 
}
</script>
<style scoped>
.img-social{
    width: 1.5em;
    border: 2px solid #f3f3f3;
    border-radius: 8px;
}
</style>